/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
// export function parseTime(time, cFormat) {
//   if (arguments.length === 0 || !time) {
//     return null
//   }
//   const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
//   let date
//   if (typeof time === 'object') {
//     date = time
//   } else {
//     if ((typeof time === 'string')) {
//       if ((/^[0-9]+$/.test(time))) {
//         // support "1548221490638"
//         time = parseInt(time)
//       } else {
//         // support safari
//         // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
//         time = time.replace(new RegExp(/-/gm), '/')
//       }
//     }
//
//     if ((typeof time === 'number') && (time.toString().length === 10)) {
//       time = time * 1000
//     }
//     date = new Date(time)
//   }
//   const formatObj = {
//     y: date.getFullYear(),
//     m: date.getMonth() + 1,
//     d: date.getDate(),
//     h: date.getHours(),
//     i: date.getMinutes(),
//     s: date.getSeconds(),
//     a: date.getDay()
//   }
//   const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
//     const value = formatObj[key]
//     // Note: getDay() returns 0 on Sunday
//     if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
//     return value.toString().padStart(2, '0')
//   })
//   return time_str
// }

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
/* export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    // return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}*/

/**
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 * 计算字符串所占字节长度
 * @param {string} input value
 * @returns {number} output value
 */
export function byteLength(str = '') {
  let len = 0
  for (let i = 0; i < str.length; i++) {
    if (str.charCodeAt(i) > 127 || str.charCodeAt(i) == 94) {
      len += 2
    } else {
      len++
    }
  }
  return len
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

/**
 * @param {Object} json
 * @returns {Array}
 */
export function param(json) {
  if (!json) return ''
  return cleanArray(
    Object.keys(json).map(key => {
      if (json[key] === undefined) return ''
      return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
    })
  ).join('&')
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ')
  if (!search) {
    return {}
  }
  const obj = {}
  const searchArr = search.split('&')
  searchArr.forEach(v => {
    const index = v.indexOf('=')
    if (index !== -1) {
      const name = v.substring(0, index)
      const val = v.substring(index + 1, v.length)
      obj[name] = val
    }
  })
  return obj
}

/**
 * @param {string} val
 * @returns {string}
 */
export function html2Text(val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
export function objectMerge(target, source) {
  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  Object.keys(source).forEach(property => {
    const sourceProperty = source[property]
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty)
    } else {
      target[property] = sourceProperty
    }
  })
  return target
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
export function toggleClass(element, className) {
  if (!element || !className) {
    return
  }
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

/**
 * @param {string} type
 * @returns {Date}
 */
export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function (...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

/**
 * @param {Array} arr
 * @returns {Array}
 */
export function uniqueArr(arr) {
  return Array.from(new Set(arr))
}

/**
 * @returns {string}
 */
export function createUniqueString() {
  const timestamp = +new Date() + ''
  const randomNum = parseInt((1 + Math.random()) * 65536) + ''
  return (+(randomNum + timestamp)).toString(32)
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += ' ' + cls
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
    ele.className = ele.className.replace(reg, ' ')
  }
}

/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string')) {
      if ((/^[0-9]+$/.test(time))) {
        // support "1548221490638"
        time = parseInt(time)
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }

    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    return value.toString().padStart(2, '0')
  })
  return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/**
 * 获取上一个月
 *
 * @date 格式为yyyy-mm-dd的日期，如：2014-01-25
 */
export function getPreMonth(date) {
  var arr = date.split('-')
  var year = arr[0]
  var month = arr[1]
  var day = arr[2]
  var days = new Date(year, month, 0)
  days = days.getDate()
  var year2 = year
  var month2 = parseInt(month) - 1
  if (month2 == 0) {
    year2 = parseInt(year2) - 1
    month2 = 12
  }
  var day2 = day
  var days2 = new Date(year2, month2, 0)
  days2 = days2.getDate()
  if (day2 > days2) {
    day2 = days2
  }
  if (month2 < 10) {
    month2 = '0' + month2
  }
  var t2 = year2 + '-' + month2 + '-' + day2

  return t2
}

/**
 * 获取下一个月
 *
 * @date 格式为yyyy-mm-dd的日期，如：2014-01-25
 */
export function getNextMonth(date) {
  var arr = date.split('-')
  var year = arr[0] // 获取当前日期的年份
  var month = arr[1] // 获取当前日期的月份
  var day = arr[2] // 获取当前日期的日
  // eslint-disable-next-line no-unused-vars
  var days = new Date(year, month, 0)
  days = days.getDate() // 获取当前日期中的月的天数
  var year2 = year
  var month2 = parseInt(month) + 1
  // eslint-disable-next-line eqeqeq
  if (month2 == 13) {
    year2 = parseInt(year2) + 1
    month2 = 1
  }
  var day2 = day
  var days2 = new Date(year2, month2, 0)
  days2 = days2.getDate()
  if (day2 > days2) {
    day2 = days2
  }
  if (month2 < 10) {
    month2 = '0' + month2
  }

  var t2 = year2 + '-' + month2 + '-' + day2
  return t2
}

export function curDayDate(data) {
  const myDate = data
  const Y = myDate.getFullYear()
  const M = myDate.getMonth() + 1
  const D = myDate.getDate()
  const curDay = Y + '-' + M + '-' + D
  return curDay
}

export function compareDate(date1, date2) {
  var result = false
  if (date1.getFullYear() > date2.getFullYear()) {
    result = true
  } else if (date1.getFullYear() == date2.getFullYear()) {
    if (date1.getMonth() > date2.getMonth()) {
      result = true
    } else if (date1.getMonth() == date2.getMonth()) {
      if (date1.getDate() > date2.getDate()) {
        result = true
      }
    }
  }
  return result
}

export function compareDateEqual(date1, date2) {
  var result = false
  if (date1.getFullYear() == date2.getFullYear()) {
    if (date1.getMonth() == date2.getMonth()) {
      if (date1.getDate() == date2.getDate()) {
        result = true
      }
    }
  }
  return result
}

export function getDaysInOneMonth(year, month) {
  month = parseInt(month, 10)
  var d = new Date(year, month, 0)
  return d.getDate()
}

// 最近七天和最近三十天时间
export function timeForMat(count) {
  // 拼接时间
  const time1 = new Date()
  time1.setTime(time1.getTime() - (24 * 60 * 60 * 1000))
  const Y1 = time1.getFullYear()
  const M1 = ((time1.getMonth() + 1) > 10 ? (time1.getMonth() + 1) : '0' + (time1.getMonth() + 1))
  const D1 = (time1.getDate() > 10 ? time1.getDate() : '0' + time1.getDate())
  const timer1 = Y1 + '-' + M1 + '-' + D1 // 当前时间
  const time2 = new Date()
  time2.setTime(time2.getTime() - (24 * 60 * 60 * 1000 * count))
  const Y2 = time2.getFullYear()
  const M2 = ((time2.getMonth() + 1) > 9 ? (time2.getMonth() + 1) : '0' + (time2.getMonth() + 1))
  const D2 = (time2.getDate() > 9 ? time2.getDate() : '0' + time2.getDate())
  // let timer2 = Y2 + '-' + M2 + '-' + D2 // 之前的7天或者30天
  // return {
  // // t1: timer1,
  // // t2: timer2
  // }
  return Y2 + '-' + M2 + '-' + D2
}

/* // 最近时间后几天
export function timeForMatNow(time1, count) {
  // 拼接时间
  time1.setTime(time1.getTime() - (24 * 60 * 60 * 1000))
  const Y1 = time1.getFullYear()
  const M1 = ((time1.getMonth() + 1) > 10 ? (time1.getMonth() + 1) : '0' + (time1.getMonth() + 1))
  const D1 = (time1.getDate() > 10 ? time1.getDate() : '0' + time1.getDate())
  const timer1 = Y1 + '-' + M1 + '-' + D1 // 当前时间
  const time2 = new Date()
  time2.setTime(time2.getTime() - (24 * 60 * 60 * 1000 * count))
  const Y2 = time2.getFullYear()
  const M2 = ((time2.getMonth() + 1) > 9 ? (time2.getMonth() + 1) : '0' + (time2.getMonth() + 1))
  const D2 = (time2.getDate() > 9 ? time2.getDate() : '0' + time2.getDate())
  // let timer2 = Y2 + '-' + M2 + '-' + D2 // 之前的7天或者30天
  // return {
  // // t1: timer1,
  // // t2: timer2
  // }
  return Y2 + '-' + M2 + '-' + D2
}*/

export function formatDate(datetime, splitStr) {
  splitStr = splitStr || ''
  if (String(datetime).indexOf('-') != -1) { // 如果已经格式化则重新转化为date形式
    datetime = new Date(datetime)
  }
  var year = datetime.getFullYear()
  var month = ('0' + (datetime.getMonth() + 1)).slice(-2)
  var date = ('0' + datetime.getDate()).slice(-2)
  var hour = ('0' + datetime.getHours()).slice(-2)
  var minute = ('0' + datetime.getMinutes()).slice(-2)
  var second = ('0' + datetime.getSeconds()).slice(-2)
  // 返回
  return {
    time: year + '-' + month + '-' + date,
    timeStr: year + splitStr + month + splitStr + date,
    timeStrA: year + '/' + month + '/' + date + ' ' + hour + ':' + minute + ':' + second,
    timeStrB: year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second,
    timeStrC: year + '年' + month + '月' + date + '日' + hour + ':' + minute + ':' + second,
    timeStrMinute: year + '-' + month + '-' + date + ' ' + hour + ':' + minute,
    timeStrD: year + '.' + month + '.' + date,
    timeStrYM: year + '-' + month,
    year: year,
    month: month,
    date: date,
    hour: hour,
    minute: minute,
    second: second
  }
}

// 2.强制保留2位小数，如：2，会在2后面补上00.即2.00
export function toDecimal2(x) {
  var f = parseFloat(x)
  if (isNaN(f)) {
    return false
  }
  var f = Math.round(x * 100) / 100
  var s = f.toString()
  var rs = s.indexOf('.')
  if (rs < 0) {
    rs = s.length
    s += '.'
  }
  while (s.length <= rs + 2) {
    s += '0'
  }
  return s
}

// 处理浮点型问题
// 解决浮点问题 加
export function accAdd(arg1, arg2) {
  var r1, r2, m
  try {
    r1 = arg1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }

  try {
    r2 = arg2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2))
  return (arg1 * m + arg2 * m) / m
}

// 解决浮点问题 乘
export function accMul(arg1, arg2) {
  var m = 0
  var s1 = arg1.toString()
  var s2 = arg2.toString()
  try {
    m += s1.split('.')[1].length
  } catch (e) { }
  try {
    m += s2.split('.')[1].length
  } catch (e) { }
  return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
}

// //解决浮点问题 减
export function accSub(arg1, arg2) {
  var r1, r2, m, n
  try {
    r1 = arg1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2))
  // last modify by deeka
  // 动态控制精度长度
  n = (r1 >= r2) ? r1 : r2
  return ((arg1 * m - arg2 * m) / m).toFixed(n)
}

export function accDiv(arg1, arg2) {
  var t1 = 0
  var t2 = 0
  var r1
  var r2
  try {
    t1 = arg1.toString().split('.')[1].length
  } catch (e) { }
  try {
    t2 = arg2.toString().split('.')[1].length
  } catch (e) { }
  r1 = Number(arg1.toString().replace('.', ''))
  r2 = Number(arg2.toString().replace('.', ''))
  return (r1 / r2) * Math.pow(10, t2 - t1)
}
// 验证时间
export function validTime(startTime, endTime) {
  var arr1 = startTime.split('-')
  var arr2 = endTime.split('-')
  var date1 = new Date(parseInt(arr1[0]), parseInt(arr1[1]) - 1, parseInt(arr1[2]), 0, 0, 0)
  var date2 = new Date(parseInt(arr2[0]), parseInt(arr2[1]) - 1, parseInt(arr2[2]), 0, 0, 0)
  if (date1.getTime() > date2.getTime()) {
    return false
  } else {
    return true
  }
  // return false
}
// 获取时间段的数组
export function getDayAll(starDay, endDay) {
  var arr = []
  var dates = []
  // 设置两个日期UTC时间
  var db = new Date(starDay)
  var de = new Date(endDay)
  // 获取两个日期GTM时间
  var s = db.getTime() - 24 * 60 * 60 * 1000
  var d = de.getTime() - 24 * 60 * 60 * 1000
  // 获取到两个日期之间的每一天的毫秒数
  for (var i = s; i <= d;) {
    i = i + 24 * 60 * 60 * 1000
    arr.push(parseInt(i))
  }
  // 获取每一天的时间  YY-MM-DD
  for (var j in arr) {
    var time = new Date(arr[j])
    var year = time.getFullYear(time)
    var mouth = (time.getMonth() + 1) >= 10 ? (time.getMonth() + 1) : ('0' + (time.getMonth() + 1))
    var day = time.getDate() >= 10 ? time.getDate() : ('0' + time.getDate())
    var YYMMDD = year + '-' + mouth + '-' + day
    dates.push(YYMMDD)
  }
  return dates
}

// 把整数秒转化为"hh:mm:ss"的时间格式.
export function formatTimeHMS(time) {
  var hh
  var mm
  var ss
  // 传入的时间为空或小于0
  if (time == null || time < 0) {
    return
  }
  // 得到小时
  hh = time / 3600 | 0
  time = parseInt(time) - hh * 3600
  if (parseInt(hh) < 10) {
    hh = '0' + hh
  }
  // 得到分
  mm = time / 60 | 0
  // 得到秒
  ss = parseInt(time) - mm * 60
  if (parseInt(mm) < 10) {
    mm = '0' + mm
  }
  if (ss < 10) {
    ss = '0' + ss
  }
  return hh + ':' + mm + ':' + ss
}

// 生成24位英文字母
export function newsetDesc() {
  const letterArr = []
  for (var i = 65, j = 0; i < 91; i++, j++) {
    letterArr[j] = String.fromCharCode(i)
  }
  return letterArr
}

// 下载图片
export function downloadIamge(imgsrc, name) { // 下载图片地址和图片名
  var image = new Image()
  // 解决跨域 Canvas 污染问题
  image.setAttribute('crossOrigin', 'anonymous')
  image.onload = function () {
    var canvas = document.createElement('canvas')
    canvas.width = image.width
    canvas.height = image.height
    var context = canvas.getContext('2d')
    context.drawImage(image, 0, 0, image.width, image.height)
    var url = canvas.toDataURL('image/png') // 得到图片的base64编码数据
    var a = document.createElement('a') // 生成一个a元素
    var event = new MouseEvent('click') // 创建一个单击事件
    a.download = name || 'photo' // 设置图片名称
    a.href = url // 将生成的URL设置为a.href属性
    a.dispatchEvent(event) // 触发a的单击事件
  }
  image.src = imgsrc
}

/**
 * 简单实现防抖方法
 * @param fn 要防抖的函数
 * @param delay 防抖的毫秒数
 * @returns {Function}
 */
export function simpleDebounce(fn, delay = 100) {
  let timer = null
  return function () {
    const args = arguments
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      fn.apply(this, args)
    }, delay)
  }
}

// 时间差
export function timeInterval(s, e) {
  const stime = Date.parse(new Date(s))
  const etime = Date.parse(new Date(e))
  // 两个时间戳相差的毫秒数
  const usedTime = etime - stime
  // 计算相差的天数
  let days = Math.floor(usedTime / (24 * 3600000))
  // 计算天数后剩余的毫秒数
  const leave1 = usedTime % (24 * 3600000)
  // 计算出小时数
  let hours = Math.floor(leave1 / 3600000)
  // 计算小时数后剩余的毫秒数
  const leave2 = leave1 % 3600000
  // 计算相差分钟数
  var minutes = Math.floor(leave2 / 60000)
  var leave3 = leave2 % (60 * 1000) // 计算分钟数后剩余的毫秒数
  var seconds = Math.round(leave3 / 1000)
  const time = days + '天' + hours + '小时' + minutes + '分钟'
  if (days < 10) {
    if (days < 0) {
      days = '00'
    } else {
      days = '0' + days
    }
  }
  if (hours < 10) {
    if (hours < 0) {
      hours = '00'
    } else {
      hours = '0' + hours
    }
  }
  if (minutes < 10) {
    if (minutes < 0) {
      minutes = '00'
    } else {
      minutes = '0' + minutes
    }
  }

  if (seconds < 10) {
    if (seconds < 0) {
      seconds = '00'
    } else {
      seconds = '0' + seconds
    }
  }

  return {
    days: days.toString(),
    hours: hours.toString(),
    minutes: minutes.toString(),
    seconds: seconds.toString()
  }
}

// 清除html中的注释内容
export function courseContextRegExp(content) {
  var content2 = content.replace(/<!--.*?-->/g, '')
  return content2
}

// 格式化html文件
export function courseContextRegExp2(mixContent) {
  if (mixContent) {
    var re2 = new RegExp('＞', 'g')
    var re1 = new RegExp('＜', 'g')
    var re4 = new RegExp('＂', 'g')
    var re5 = new RegExp('＇', 'g')
    var msg = mixContent.replace(re1, '<') // 执行替换成空字符
    var msg2 = msg.replace(re2, '>') // 执行替换成空字符
    var msg3 = msg2.replace(re4, '"') // 执行替换成空字符
    var msg4 = msg3.replace(re5, "'") // 执行替换成空字符
    return msg4
  } else {
    return ''
  }
}

// 当前时间=》格式化短信时间
export function smsTimeFormat(mydate) {
  // var year = mydate.getFullYear();
  var month = mydate.getMonth() + 1
  var day = mydate.getDate()
  var hour = mydate.getHours()
  var minutes = mydate.getMinutes()
  var now = ''
  if (minutes < 10) {
    minutes = '0' + minutes
  }

  if (hour <= 12) {
    now = '上午'
  } else {
    now = '下午'
  }
  var seconds = mydate.getSeconds()
  if (seconds < 10) {
    seconds = '0' + seconds
  }
  // 03月28日 上午09:40
  var time = month + '月' + day + '日  ' + now + '' + hour + ':' + minutes
  return time
}
// 计算两个时间之间相差的天数——入参是new Date(‘2023-01-13 10:14:30’)这样的格式
export function getDiffDay(date_1, date_2) {
  let totalDays, diffDate
  const myDate_1 = Date.parse(date_1)
  const myDate_2 = Date.parse(date_2)
  diffDate = Math.abs(myDate_1 - myDate_2)
  totalDays = Math.floor(diffDate / (1000 * 3600 * 24))
  return totalDays
}

// 无限debugger
export function consoleDebugger() {
  function breakDebugger() {
    if (new checkDebugger().check) {
      breakDebugger()
    }
  }
  function checkDebugger() {
    const now = new Date();
    eval('(function () {debugger;false;})()')
    const dur = Date.now() - now
    if (dur < 5) {
      return { check: false }
    } else {
      return { check: true }
    }
  }
  setInterval(() => {
    eval('(function () {debugger;true;})()')
    breakDebugger()
  }, 500)
};


import CryptoJS from 'crypto-js' // 加密
//设置cookie  保存密码
/**
 *
 * @param {*} portId value 值
 * @param {*} key  key key值
 * @param {*} exdays  days 天数
 */
export function setCookie(portId, key, exdays) {
  // Encrypt，加密账号密码
  var value = CryptoJS.AES.encrypt(
    portId + '',
    'secretkey123'
  ).toString();
  var exdate = new Date(); //获取时间
  exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
  //字符串拼接cookie，为什么这里用了==，因为加密后的字符串也有个=号，影响下面getcookie的字符串切割，你也可以使用更炫酷的符号。
  window.document.cookie =
    key +
    "==" +
    value +
    ";path=/;expires=" +
    exdate.toGMTString();
}
//
/**
 * 读取cookie
 * @param {*} key
 * @returns
 */
export function getCookie(key) {
  if (document.cookie.length > 0) {
    var arr = document.cookie.split('; ') // 这里显示的格式请根据自己的代码更改
    for (var i = 0; i < arr.length; i++) {
      var arr2 = arr[i].split('==') // 根据==切割
      // 判断查找相对应的值
      if (arr2[0] == key) {
        var bytes = CryptoJS.AES.decrypt(arr2[1], 'secretkey123')
        var res = bytes.toString(CryptoJS.enc.Utf8);
        return res
      }
    }
  }
}



/**
 * 订单导出下载
 * @param {*} filterVal  表格筛选内容
 * @param {*} jsonData  list列表
 */
function formatJsonExcel(filterVal, jsonData) {
  return jsonData.map(v => filterVal.map(j => {
    if (j === 'goodGiveEntity') { // 支付状态
      let str = ''
      if (v[j] && v[j].goodGiveEntityDetailList) {
        v[j].goodGiveEntityDetailList.map((item) => {
          str += `${item.title}
                  `
        })
      }
      return str
    } else if (j === 'timestamp') {
      return parseTime(v[j])
    } else if (j === 'payFlag') { // 支付状态
      if (v[j] == 1) {
        return '已支付'
      } else {
        return '未支付'
      }
    } else if (j === 'distName') { // 达人名称
      if (v[j]) {
        return v[j]
      } else if (v['distMobile']) {
        return v['distMobile'].slice(0, 3) + '****' + v['distMobile'].slice(7)
      } else {
        return ''
      }
    }

    else if (j === 'backFlag') {
      if (v[j] == 1) {
        return '已退款'
      } else {
        return '未退款'
      }
    } else if (j === 'distCustomRatio') {
      if (v['liveDistFlag'] == '1') {
        return v['liveDistRatio'] + '%'
      } else {
        return v['distCustomRatio'] || 0 + '%'
      }
    }
    else if (j === 'orderSourceDict') { // 订单来源
      if (v['liveDistFlag'] == '1') {
        return '小程序推广计划'
      } else if (v[j] == 'zhibo') {
        return '直播'
      } else if (v[j] == 'guazai') {
        return '视频挂载'
      } else if (v[j] == 'doudian') {
        return '抖店'
      } else if (v[j] == 'shipinhao_applet' || v[j] == 'shipinhao_gongzhonghao') {
        return '微信小程序/H5'
      } else if (v[j] == 'shipinhao_shop') {
        return '视频号小店'
      } else if (v[j] == 'xiaohongshu') {
        return '小红书'
      } else {
        return '平台订单'
      }
    } else if (j === 'platformDict') { // 订单来源
      if (v[j] == 'douyin') {
        return '抖音'
      } else if (v[j] == 'doudian') {
        return '抖店'
      } else if (v[j] == 'kuaishou') {
        return '快手'
      } else if (v[j] == 'shipinhao_applet' || v[j] == 'shipinhao_gongzhonghao') {
        return '微信小程序/H5'
      } else if (v[j] == 'xiaohongshu') {
        return '小红书'
      } else {
        return '其他'
      }
    } else if (j === 'qualificationFlag') {
      if (v[j] == 1) {
        return '通过'
      } else {
        return '未通过'
      }
    } else if (j === 'distProgress') { // 结算状态
      if (v[j] == '1') {
        return '已结算'
      } else {
        return '未结算'
      }
    } else if (j === 'sendStatus') {
      if (v[j] == 0) {
        return '待发货'
      } else {
        return '已发货'
      }
    } else if (j === 'timestamp') {
      return parseTime(v[j])
    } else if (j === 'refundAuditProgress') { // 售后状态
      if (v[j] == 'submit') {
        return '待讲师处理'
      } else if (v[j] == 'reject') {
        return '已驳回'
      } else if (v[j] == 'agree') {
        return '同意退款，退款成功'
      }
    } else if (j === 'jieru1') {
      return '未介入'
    } else if (j === 'dealDateFlag') { // 售后状态
      if (v[j] == '1') {
        return '限时处理订单（24H）'
      } else if (v[j] == '2') {
        return '限时处理订单（48H）'
      }
    } else if (j === 'applyArbitrationFlag') { // 仲裁状态
      if (v[j] == '1') {
        return '仲裁待处理'
      } else {
        return ''
      }
    } else if (j === 'highRiskFlag') { // 高危客诉状态
      if (v[j] == '1') {
        return '高危客诉'
      } else {
        return ''
      }
    } else if (j === 'distProgress') { // 结算状态
      if (v[j] == '1') {
        return '已结算'
      } else {
        return '未结算'
      }
    } else if (j === 'payPlatform') { // 支付方式
      if (v[j] == 'weixin') {
        return '微信'
      } else if (v[j] == 'zhifubao'){
        return '支付宝'
      }else{
        return '其他'
      }
    } else if (j === 'watchSecs') { // 观看时长
      return formatTimeHMS(v[j])
    } else if (j === 'studyRatio') { // 观看进度
      return v[j] * 100 + '%'
    } else if (j === 'applyArbitrationFlagelse') { // 处理状态
      if (v[j] == '1') {
        return '限时处理订单（24H）'
      } else if (v[j] == '2') {
        return '限时处理订单（48H）'
      }
    } else if (j === 'order.backFlag') {
      return v['order'] && v['order']['backFlag'] == 1 ? '已退款' : '未退款'
    } else if (j === 'order.receiverName') {
      return v['order'] ? v['order']['receiverName'] : ''
    } else if (j === 'order.receiverMobile') {
      return v['order'] ? v['order']['receiverMobile'] : ''
    } else if (j === 'order.receiverAddress') {
      return v['order'] ? v['order']['receiverAddress'] : ''
    } else {
      return v[j]
    }
  }))
}
/**
 * 订单导出下载
 * @param {*} tHeader 表格标题
 * @param {*} filterVal  表格筛选内容
 * @param {*} list  list列表
 */
export function downLoadExcel(tHeader, filterVal, list, filename) {
  import('@/vendor/Export2Excel').then(excel => {
    const data = formatJsonExcel(filterVal, list)
    excel.export_json_to_excel({
      header: tHeader,
      data,
      filename: filename || '订单统计'
    })
  })
};
/**
 * DateAdd功能
 * @param interval,字符串表达式，表示要添加的时间间隔.
 * @param number,数值表达式，表示要添加的时间间隔的个数.
 * @param date,时间对象.
 */
export function DateAdd(interval, number, date) {
  if (interval == 'y') {
    date.setFullYear(date.getFullYear() + number);
    return formatDate(date);
  } else if (interval == 'm') {
    let newMonth = date.getMonth() + number;
    let newYear = date.getFullYear();
    if (newMonth > 12) {
      newMonth = newMonth - 12;
      newYear = newYear + 1;
    } else if (newMonth < 0) {
      newMonth = 12 + newMonth;
      newYear = newYear - 1;
    }
    date.setFullYear(newYear);
    date.setMonth(newMonth);
    return formatDate(date);
  }
}
